/**
 * @file  src\mobile\components\wantAd.js
 * @brief  This file is responsible for want ad ui
 * @date   April, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import { pageURLs } from "../../constants/v2/pageURLs";
import React from "react";
import { useNavigate } from "react-router-dom";

const NotificationDrop = ({ unreadInappNotificationCount }) => {
  const navigate = useNavigate();
  return (
    <a
      href={void 0}
      role="button"
      className="text-center px-0 justify-content-center align-items-center"
      onClick={() => {
        navigate(pageURLs.mobileInapp);
      }}
    >
      {/* COMMENT AS OF NOW TO LOOK INTO IT */}
      {unreadInappNotificationCount > 0 && (
        <div className="bell-icon-count">{unreadInappNotificationCount}</div>
      )}
      <svg
        width="18"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.7504 21C15.7504 21.1989 15.6714 21.3897 15.5308 21.5303C15.3901 21.671 15.1993 21.75 15.0004 21.75H9.00042C8.80151 21.75 8.61074 21.671 8.47009 21.5303C8.32944 21.3897 8.25042 21.1989 8.25042 21C8.25042 20.8011 8.32944 20.6103 8.47009 20.4697C8.61074 20.329 8.80151 20.25 9.00042 20.25H15.0004C15.1993 20.25 15.3901 20.329 15.5308 20.4697C15.6714 20.6103 15.7504 20.8011 15.7504 21ZM20.7989 18C20.6687 18.2292 20.4798 18.4196 20.2516 18.5514C20.0233 18.6833 19.764 18.7518 19.5004 18.75H4.50042C4.23673 18.7496 3.9778 18.6798 3.74972 18.5475C3.52164 18.4151 3.33247 18.225 3.20128 17.9963C3.07008 17.7676 3.0015 17.5083 3.00245 17.2446C3.0034 16.9809 3.07384 16.7222 3.20667 16.4944C3.72698 15.5981 4.50042 13.0631 4.50042 9.75C4.50042 7.76088 5.29059 5.85322 6.69712 4.4467C8.10364 3.04018 10.0113 2.25 12.0004 2.25C13.9895 2.25 15.8972 3.04018 17.3037 4.4467C18.7102 5.85322 19.5004 7.76088 19.5004 9.75C19.5004 13.0622 20.2748 15.5981 20.7951 16.4944C20.9293 16.7225 21.0002 16.9822 21.0007 17.2468C21.0012 17.5114 20.9312 17.7714 20.7979 18H20.7989ZM19.5004 17.25C18.7757 16.0059 18.0004 13.1297 18.0004 9.75C18.0004 8.1587 17.3683 6.63258 16.2431 5.50736C15.1178 4.38214 13.5917 3.75 12.0004 3.75C10.4091 3.75 8.883 4.38214 7.75778 5.50736C6.63256 6.63258 6.00042 8.1587 6.00042 9.75C6.00042 13.1306 5.22417 16.0069 4.50042 17.25H19.5004Z"
          fill="#636569"
        ></path>
      </svg>

      <span>&nbsp; Notifications</span>
    </a>
  );
};

export default NotificationDrop;
